import NotificationService from './NotificationService';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';

// URL is something like 'wss://localhost:9443/socket/801/pr1f0nts/websocket'
//                       'https://localhost:9443/socket/276/erk0gzk3
const WS_URL_RE = /^wss?:\/\/.+\/socket\/[0-9]+\/(.+)\/websocket$/;
const HTTP_URL_RE = /^https?:\/\/.+\/socket\/[0-9]+\/(.+)$/;

function defaultMessageHandler(message) {
  console.log('Message received', message);
}

function defaultSubscriptionHandler(subscription) {
  console.log('Subscription', subscription);
}

function realCb(messageHandler, frame, channel) {
  console.log('frame: ', frame);
  console.log('channel: ', channel);
  if (frame.body) {
    if (channel) {
      if (frame.headers && frame.headers.channel == channel) {
        messageHandler(JSON.parse(frame.body));
      }
    } else {
      messageHandler(JSON.parse(frame.body));
    }
  }
}

// TODO implement disconnection on destroy
export default class WebSocketNotificationService
    extends NotificationService {

  constructor() {
    super();

    this.connecting = false;
    this.stompClient = null;
    this.awaitingTopics = [];
  }

  configure(args) {
    if (!args.url) {
      throw Error('Missing parameter: url');
    }

    this.serverUrl = args.url;
    this.configured = true;
  }

  connect() {
    if (!this.configured) {
      throw Error('WebSocketNotificationService is not configured');
    }

    this.connecting = true;

    // localStorage.debug = '*';
    let ws = new SockJS(this.serverUrl, [], {devel: true, debug: "*"});

    this.stompClient = Stomp.over(ws);

    const headers = {};

    let awaitingTopics = this.awaitingTopics;
    let stompClient = this.stompClient;

    const self = this;
    function onConnectSuccess(frame) {
      console.log('Web socket connected');

      // -----------------------------------------------------------------------
      // SUBSCRIBE TO AWAITING TOPICS
      // -----------------------------------------------------------------------
      awaitingTopics.forEach((topic) => {
        const t = typeof topic.topic === 'function'
            ? topic.topic()
            : topic.topic
            ;
        console.log('Subscribing to topic: ', t);
        const subscription = stompClient.subscribe(t, topic.messageHandler);
        topic.subscriptionHandler(subscription);
      });
      // -----------------------------------------------------------------------

      self.connecting = false;
    }

    function onConnectError(error) {
      console.log('Connection error', error);
      self.connecting = false;
    }

    this.stompClient.connect(headers, onConnectSuccess, onConnectError);
  }

  isConnected() {
    if (!this.configured) {
      throw Error('WebSocketNotificationService is not configured');
    }

    return this.stompClient
        && this.stompClient.connected;
  }

  disconnect() {
    if (!this.configured) {
      throw Error('WebSocketNotificationService is not configured');
    }

    this.isConnected() && this.stompClient.disconnect();
  }

  getSessionId() {
    if (!this.configured) {
      throw Error('WebSocketNotificationService is not configured');
    }

    if (!this.stompClient) {
      throw Error('Cannot find stomp client');
    }

    let url = this.stompClient.ws._transport.url;
    console.log('STOMP CLIENT CONNECTION URL', url);
    // URL is something like 'wss://localhost:9443/socket/801/pr1f0nts/websocket'
    let match = WS_URL_RE.exec(url);
    if (match) {
      console.log('MATCH', match);
      const sessionId = match[1];
      console.log('SID', sessionId);
      return sessionId;
    } else {
      match = HTTP_URL_RE.exec(url);
      if (match) {
        console.log('MATCH', match);
        const sessionId = match[1];
        console.log('SID', sessionId);
        return sessionId;
      } else {
        throw Error('Error parsing stomp client connection url. Url: ' + url);
      }
    }
  }

  subscribe(topic,
            messageHandler = defaultMessageHandler,
            subscriptionHandler = defaultSubscriptionHandler,
            channel) {
    if (!this.configured) {
      throw Error('WebSocketNotificationService is not configured');
    }

    //const topic = () => '/user/queue/user-user' + this.getSessionId();
    const handler = (frame) => realCb(messageHandler, frame, channel);
    //const handler = (frame) => realCb(messageHandler, frame);

    if (this.isConnected()) {
      const t = typeof topic === 'function'
          ? topic()
          : topic
          ;
      console.log('Subscribing to topic: ', t);
      const subscription = this.stompClient.subscribe(t, handler);
      subscriptionHandler(subscription);
    } else {
      this.awaitingTopics.push({ topic, messageHandler: handler, subscriptionHandler });
      if (!this.connecting) {
        this.connect();
      }
    }
  }

  subscribePrivate(messageHandler = defaultMessageHandler,
                   subscriptionHandler = defaultSubscriptionHandler,
                   channel) {
    if (!this.configured) {
      throw Error('WebSocketNotificationService is not configured');
    }

    const topic = () => '/user/queue/user-user' + this.getSessionId();
    this.subscribe(topic, messageHandler, subscriptionHandler, channel);
  }
}
